import lz from "lz-string";

import { Auth, API } from "aws-amplify";

const PAGE_SIZE = 20000;

async function csv() {
  return API.get("prod-slippy", "/bet_csv", {
    headers: {
      Authorization: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    }
  });
}

async function get(pageSize = PAGE_SIZE, offset = 0) {
  return API.get("prod-slippy", "/bet_history", {
    headers: {
      Authorization: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    },
    queryStringParameters: {
      page_size: pageSize,
      offset
    }
  });
}

async function clearCache() {
  for (const key of Object.keys(localStorage)) {
    if (key.startsWith("BETS|")) {
      localStorage.removeItem(key);
    }
  }
}

async function getAll(cache = true) {
  const resp = {
    bets: [],
    csv: ""
  };

  let offset = 0;
  for (;;) {
    const cacheKey = `BETS|${PAGE_SIZE}|${offset}`;
    console.log(`checking cache for ${cacheKey}`);

    let page = null;
    if (cache) {
      const cached = localStorage.getItem(cacheKey);
      if (cached) {
        try {
          const decompressed = lz.decompress(cached);
          page = JSON.parse(decompressed);
          console.log(`successfully read cache item ${cacheKey}`);
        } catch (err) {
          localStorage.removeItem(cacheKey);
        }
      }
    }

    if (!page) {
      page = await get(PAGE_SIZE, offset);

      if (cache) {
        const str = JSON.stringify(page);
        const compressed = lz.compress(str);

        if (page.bets.length === PAGE_SIZE) {
          localStorage.setItem(cacheKey, compressed);
          console.log(`wrote cache item ${cacheKey}`);
        }
      }
    }

    resp.bets.push(...page.bets);
    resp.csv = page.csv;

    if (page.bets.length === PAGE_SIZE) {
      offset += PAGE_SIZE;
    } else {
      break;
    }
  }

  return resp;
}

export { get, getAll, csv, clearCache };
